/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowALeftIcon24Solid = forwardRef('ArrowALeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.998 18.814a1.5 1.5 0 1 1-2.121 2.122l-6.284-6.284a3.75 3.75 0 0 1 0-5.304l6.284-6.284a1.5 1.5 0 1 1 2.121 2.122L5.684 10.5H21a1.5 1.5 0 1 1 0 3H5.684l5.314 5.314Z" })));
});
